<sdc-bo-shell [expanded]="expanded()">
  <sdc-bo-sidebar
    sdc-shell-sidebar
    [expanded]="expanded()"
    [class.gs-sidebar-expanded]="expanded()"
    (expandedChange)="expanded.set($event)"
    [titleStrong]="appName"
    [titleLight]="productName">
    <button
      type="button"
      class="gs-sidebar-logo-toggle"
      sdc-sidebar-logo
      data-cy="sidebar-logo-toggle"
      [title]="expanded() ? 'Collapse sidebar' : 'Expand sidebar'"
      aria-label="Toggle sidebar"
      [attr.aria-expanded]="expanded()"
      (click)="toggleSidebar()">
      <img [src]="logo" alt="club logo" />
    </button>

    @for (item of navigationItems(); track item.path) {
      <a
        class="sdc-sidebar-item"
        routerLinkActive="sdc-sidebar-item-active"
        [routerLinkActiveOptions]="activeMatchOptions"
        [routerLink]="['/private', item.path]"
        [queryParams]="item.queryParams"
        [title]="item.title"
        [attr.data-cy]="item.dataCy">
        <ng-icon [name]="item.icon" size="20px" />
        <span class="sdc-sidebar-item-label">{{ item.label }}</span>
      </a>
    }

    @if (adminToolsItems().length) {
      <ng-container sdc-sidebar-footer>
        <span class="sdc-sidebar-section-label">Admin Tools</span>
        @for (item of adminToolsItems(); track item.path) {
          <a
            class="sdc-sidebar-item"
            routerLinkActive="sdc-sidebar-item-active"
            [routerLinkActiveOptions]="activeMatchOptions"
            [routerLink]="['/private', item.path]"
            [queryParams]="item.queryParams"
            [title]="item.title"
            [attr.data-cy]="item.dataCy">
            <ng-icon [name]="item.icon" size="20px" />
            <span class="sdc-sidebar-item-label">{{ item.label }}</span>
          </a>
        }
      </ng-container>
    }
  </sdc-bo-sidebar>

  <sdc-bo-header
    sdc-shell-header
    [titleStrong]="expanded() ? '' : appName"
    [titleLight]="expanded() ? '' : productName">
    @if (isAdmin()) {
      <sdc-club-switcher
        sdc-header-end
        [clubs]="clubs"
        [currentClub]="club()"
        (clubSelect)="switchClub($event)" />
    }
    <sdc-services-dropdown
      sdc-header-end
      [club]="club()"
      [currentServiceKey]="currentServiceKey"
      [environment]="sdcEnv()"
      [services]="services()" />
    <sdc-user-menu sdc-header-end [label]="username()">
      <button
        type="button"
        class="sdc-user-menu-item"
        data-cy="logout-button"
        (click)="logout()">
        Log Out
      </button>
    </sdc-user-menu>
  </sdc-bo-header>

  <router-outlet />

  <sdc-bo-footer sdc-shell-footer text="Powered by 3D Digital Venue">
    <a [href]="'mailto:' + supportEmail">Contact us</a>
    <span>Version {{ version }}</span>
  </sdc-bo-footer>
</sdc-bo-shell>
